import { render, staticRenderFns } from "./DashboardWebServiceCircularStatus.vue?vue&type=template&id=19a0f6c1&scoped=true"
import script from "./DashboardWebServiceCircularStatus.vue?vue&type=script&lang=js"
export * from "./DashboardWebServiceCircularStatus.vue?vue&type=script&lang=js"
import style0 from "./DashboardWebServiceCircularStatus.vue?vue&type=style&index=0&id=19a0f6c1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a0f6c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a0f6c1')) {
      api.createRecord('19a0f6c1', component.options)
    } else {
      api.reload('19a0f6c1', component.options)
    }
    module.hot.accept("./DashboardWebServiceCircularStatus.vue?vue&type=template&id=19a0f6c1&scoped=true", function () {
      api.rerender('19a0f6c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardWebServiceCircularStatus.vue"
export default component.exports